(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mui-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mui-video-carousel')) {
    class MuiVideoCarousel extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-mui-track]');
        this.videos = [...this.querySelectorAll('[data-mui-video]')];
        const previous = this.querySelector('[data-mui-previous]');
        const next = this.querySelector('[data-mui-next]');
        const update = () => {
          previous.disabled = this.track.scrollLeft <= 2;
          next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
        };
        const move = direction => {
          const cards = [...this.track.children];
          const current = this.track.scrollLeft;
          const positions = cards.map(card => card.offsetLeft - cards[0].offsetLeft);
          const target = direction > 0 ? positions.find(position => position > current + 3) : positions.toReversed().find(position => position < current - 3);
          this.track.scrollTo({ left: target ?? (direction > 0 ? this.track.scrollWidth : 0), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        this.intersectionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.intersectionRatio < 0.5) entry.target.querySelector('video').pause(); });
        }, { threshold: [0, 0.5], root: null });
        this.videos.forEach(video => {
          const media = video.closest('[data-mui-media]');
          const play = media.querySelector('[data-mui-play]');
          const error = media.querySelector('[data-mui-error]');
          video.muted = false;
          video.defaultMuted = false;
          video.volume = 1;
          play.addEventListener('click', () => {
            error.hidden = true;
            if (!video.dataset.muiLoaded) {
              video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
              video.dataset.muiLoaded = 'true';
              video.load();
            }
            media.setAttribute('data-mui-started', '');
            video.controls = true;
            video.removeAttribute('tabindex');
            video.muted = false;
            const result = video.play();
            if (result) result.catch(() => {
              media.removeAttribute('data-mui-playing');
              error.hidden = false;
            });
          }, options);
          video.addEventListener('play', () => media.setAttribute('data-mui-playing', ''), options);
          ['pause', 'ended'].forEach(name => video.addEventListener(name, () => media.removeAttribute('data-mui-playing'), options));
          video.addEventListener('error', () => { media.removeAttribute('data-mui-playing'); error.hidden = false; }, options);
          this.intersectionObserver.observe(media);
        });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach(video => video.pause());
        }, options);
        update();
      }
      disconnectedCallback() {
        this.videos?.forEach(video => video.pause());
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.controller = null;
      }
    }
    customElements.define('mui-video-carousel', MuiVideoCarousel);
    document.addEventListener('play', event => {
      if (!(event.target instanceof HTMLVideoElement)) return;
      const current = event.target;
      const currentInCarousel = Boolean(current.closest('mui-video-carousel'));
      document.querySelectorAll(currentInCarousel ? 'video' : 'mui-video-carousel video').forEach(video => {
        if (video !== current && !video.paused) video.pause();
      });
    }, true);
  }

  } catch(e) { console.error(e); }
})();
})();
